module.exports = {};



//////////////////
// WEBPACK FOOTER
// /Users/gebb/Desktop/live/~/core-js/library/modules/_iterators.js
// module id = 27
// module chunks = 0